import {useFetchAgentDetailsQuery} from '../../../generated/graphql';
import {convertAgent} from '../utilData';
import {Agent} from '../utilTypes';

/**
 * Information about a single agent.
 */
export const useAgent = (agentId: string) => {
  const {data, loading, error} = useFetchAgentDetailsQuery({
    variables: {
      agentId,
    },
  });
  if (loading || error || !data?.launchAgent) {
    return {error, loading, agent: undefined};
  }
  const agent: Agent = convertAgent(data.launchAgent);
  return {
    agent,
    loading: undefined,
    error: undefined,
  };
};
